var _g, _g2, _g3, _g4, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28323_8140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5 24C38.5 21.7118 37.9584 19.456 36.9196 17.4171C35.8808 15.3783 34.3741 13.6143 32.5229 12.2693",
    stroke: "#0989A5",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_28323_8140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5 24C38.5 21.7118 37.9584 19.456 36.9196 17.4171C35.8808 15.3783 34.3741 13.6143 32.5229 12.2693",
    stroke: "#0989A5",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_28323_8140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5 24C38.5 21.7118 37.9584 19.456 36.9196 17.4171C35.8808 15.3783 34.3741 13.6143 32.5229 12.2693",
    stroke: "#0989A5",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_28323_8140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5 24C38.5 21.7118 37.9584 19.456 36.9196 17.4171C35.8808 15.3783 34.3741 13.6143 32.5229 12.2693",
    stroke: "#0989A5",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_28323_8140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5 24C38.5 21.7118 37.9584 19.456 36.9196 17.4171C35.8808 15.3783 34.3741 13.6143 32.5229 12.2693",
    stroke: "#0989A5",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28323_8140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_28323_8140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_28323_8140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_28323_8140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_28323_8140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.73e8c2b250c1d2e0124d1fee2ce20b74.svg";
export { ForwardRef as ReactComponent };